// ponytail: CommonJS so `node` can run its test with no jest/babel setup; the ESM component imports it fine via babel interop.
//
// The meeting header shows two ratings side by side, never blended:
//
//   - Human rating: the HUMINT meeting score (`human_average`), the mean of the
//     respondents' one-tap answer to "how would you rate the value of this
//     meeting?" (HUMINT spec v1.0 §4.1). NOT the average of the per-person
//     ratings: the spec keeps the meeting score and individual scores as two
//     independent instruments, and the per-person averages stay on the
//     attendee cards.
//   - AI rating: the Claude meeting-level composite (`meeting.ai_composite`),
//     the weighted sum of the 7-dimension rubric. The API computes it, because
//     the client's weights never leave the server (spec §6.2).
//
// The legacy per-review GPT-4 score (`reviews[].rating_ai`) is deliberately not
// used. It rates a PERSON from a reviewer's free text, not the meeting, and spec
// v0.2 §5.3 retires it. A meeting with no composite shows no AI rating.
function computeMeetingRatings(meeting) {
  return {
    humanRating: toRating(meeting && meeting.human_average),
    aiRating: toRating(meeting && meeting.ai_composite),
  };
}

// Values arrive as numbers or numeric strings. Missing, null and '' are "no
// rating", and must be rejected BEFORE coercing: Number(null) and Number('')
// are 0, which would publish a confident zero.
function toRating(raw) {
  if (raw === null || raw === undefined || raw === '') return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : round1(n);
}

function round1(n) {
  return Math.round(n * 10) / 10;
}

module.exports = { computeMeetingRatings };
